<template>
  <div class="comContent">
    <div style="margin: 20px auto">
      <el-button size="small" style="width: 160px" @click="back()"
        >返回</el-button
      >
    </div>
    <myTable
      :index="index"
      :selection="false"
      :page="page"
      :showpage="false"
      :operation="false"
      :table-data="tableData"
      :table-option.sync="tableOption"
      @page-change="getList"
      :expand="false"
    >
      <template slot="beInvoiceConfig" slot-scope="scope">
        <span style="color: #67c23a" v-if="scope.row.beInvoiceConfig">完成</span>
        <span style="color: #000000" v-if="!scope.row.beInvoiceConfig">待办</span>
      </template>
      <!--  -->
      <template slot="orgName" slot-scope="scope">
        <span   v-if="scope.row.provinceId == -1">
          省直</span
        >
        <span   v-if="scope.row.provinceId != -1">
          {{ scope.row.orgName }}</span >
      </template>

      <template slot="saleController" slot-scope="scope">
        <span style="color: #67c23a" v-if="scope.row.saleController">开启</span>
        <span style="color: #000000" v-if="!scope.row.saleController"
          >关闭</span
        >
      </template>
      <template slot="operation" slot-scope="scope">
        <div class="linkView">
          <el-link
            type="primary"
            :underline="false"
            @click="switchContral(scope.row, true)"
            style="margin-right: 10px"
            v-if="!scope.row.saleController"
          >
            开启控制
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="switchContral(scope.row, false)"
            style="margin-right: 10px"
            v-if="scope.row.saleController"
          >
            关闭控制
          </el-link>
        </div>
      </template>
    </myTable>
  </div>
</template>
<script>
import myTable from "@/components/myTable";
import _ from "lodash";
import { orgConfigDbList, orgConfigOperate } from "@/api/invoiceOps";
export default {
  components: { myTable },
  props: {},
  data() {
    return {
      form: {},
      operation: false,
      selection: true,
      index: true,
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [{ id: 1 }],
      searchData: {},
      tableOption: [
        { label: "地办", prop: "orgName" ,slot:true},
        { label: "公司信息", prop: "shopName"},
        {
          label: "数电配置",
          prop: "beInvoiceConfig",
          customHeader: true,
          type: "digitConfig",
          content:
            "若地办有多个康贝号（收款主体），完成任一数电配置即认为地办完成配置",
          slot: true,
        },
        {
          label: "采购控制",
          prop: "saleController",
          customHeader: true,
          type: "procureConfig",
          content: "开启采购控制后：未完成数电配置时，不允许诊所采购",
          slot: true,
        },
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 150,
          align: "center",
        },
      ],
    };
  },
  filters: {},
  created() {},
  mounted() {
    const { tab, status } = this.$route.query;
    this.getList(1);
  },
  methods: {
    back(row) {
      this.$router.push({
        path: "./invoiceCenter-invoiceDigitConfig",
        
      });
    },
    getList(current) {
      const params = Object.assign(
        {},
        {
          orgCode: this.$route.query.orgCode,
        }
      );
      orgConfigDbList(params).then((data) => {
        if (data) {
          this.tableData = data;
        } else {
          this.tableData = [];
        }
      });
    },
    switchContral(row, type) {
      orgConfigOperate({
        id: row.id,
        controllerFlag: type ? 1 : 0,
      }).then((data) => {
        if (data) {
          this.getList(1);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}

::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}

.linkView {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .el-link {
    margin: 5px;
  }
}
</style>
